module.exports = __webpack_public_path__ + "static/media/iconCoursesLiveActive.ca7153e5.svg";